const NORMALIZE_FORM = 'NFD';
declare const external_file_countries;
declare const external_file_city_relations;
declare const externalFileAirports ;

function normalize(name: string): string {
  return name && name.normalize ? name.normalize(NORMALIZE_FORM).replace(/[\u0300-\u036f]/g, '').replace(/-/g, ' ') : '';
}

export function getAlpha2Code(country: string): string {
  const entryNames = external_file_countries.map((entry: string) => 
    ({name : entry.split(' (')[0], Alpha2: entry.split('(')[1].replace(')', '')}));
  const entryName = entryNames.find(entry => {
    return normalize(entry.name).toUpperCase().trim().includes(normalize(country).trim().toUpperCase());
  });
  return entryName ? entryName.Alpha2 : null;
}

// Temporary logic, delete when we receive country code
export function getCountryCodeByCity(cityCode: string): string {
  const city = external_file_city_relations.find(
    (item) => item.CityCode === cityCode
  );
  return city ? city.CountryCode : null;
}

// Temporary logic, delete when we receive country code
export function getCountryCodeByAirport(airportCode: string) {
  for (let entry of externalFileAirports) {
    if (entry.includes(`(${airportCode})`)) {
      let countryCode = entry.match(/\((\w{2})\)$/);
      return countryCode ? countryCode[1] : null;
    }
  }
  return null;
}

// Temporary logic, delete when we receive country code
export function getCountryCode(code: string): string | null {
  let countryCode = getCountryCodeByCity(code);
  if (!countryCode) {
    countryCode = getCountryCodeByAirport(code);
  }
  return countryCode;
}

